import { render, staticRenderFns } from "./HandoverMatterHandle.vue?vue&type=template&id=72587cc1&scoped=true&"
import script from "./HandoverMatterHandle.vue?vue&type=script&lang=ts&"
export * from "./HandoverMatterHandle.vue?vue&type=script&lang=ts&"
import style0 from "./HandoverMatterHandle.vue?vue&type=style&index=0&id=72587cc1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72587cc1",
  null
  
)

export default component.exports